// Central content. Edit brand + projects here.
export const BRAND = {
  name: "Kaya Amah",
  full: "Kaya Amah",
  role: "Keynote & Website Designer",
  kicker: "Creative strategist",
  email: "awazakaya@gmail.com",
  behance: "https://www.behance.net/KayaAmah",
  socials: [
    { label: "Behance", href: "https://www.behance.net/KayaAmah" },
  ],
};

export const SEO_HOME = {
  title: "Kaya The Designer | Kaya Amah, Keynote & Website Design",
  description:
    "Kaya Amah is a Florida-based creative strategist designing cinematic keynote presentations and brand-led websites for ambitious teams and enterprise brands.",
};

const IMG = "https://static.prod-images.emergentagent.com/jobs/ec872f1e-40ea-45ab-a3c0-6329cc54fb21/images";

export const MEDIA = {
  heroBg: `${IMG}/ce13e33c5d84ff648b636a9ae3cbf6d6e140538c9b7de04ac73c38aa10050223.jpeg`,
  heroRing: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/9is8ya91_AdobeStock_1801980545.webp",
  pinkWater: "/media/unsinkable-pink-water.webp",
  videoPoster: `${IMG}/57f9d3e374e84fbca5339f41765eba62c0f4b23ffebc95fe4be2e70c9db2569f.jpeg`,
  portrait: `${IMG}/2415e512e050e6578083d9b202cc28139131fedfe7f0c050c9366dff39ba9a4d.jpeg`,
  faceHero: "/media/chrome-face.webp",
};

export const LOGOS = [
  "Oracle", "Expedia", "Vital Farms", "Lenovo", "Panasonic", "Epson",
  "Vrbo", "TrueCommerce", "Abbott", "Cellipont", "Uberflip",
];

export const RESULTS = [
  { value: 100, suffix: "+", label: "Decks & websites designed" },
  { value: 15, suffix: "+ yrs", label: "As a designer" },
  { text: "Fortune 1000", label: "clients served" },
];

export const TESTIMONIALS = [
  {
    quote:
      "She designed the logo that now represents our institute, a visual identity that not only captures the spirit of our mission but also resonates deeply with the diverse communities we serve. She demonstrated patience with the board, attentiveness to intercultural dynamics, and an impressive capacity to synthesise diverse voices into a unifying design.",
    author: "Veronica Q.",
    org: "Co-founder, The Language Attitude Institute",
    rating: 5,
  },
  {
    quote:
      "Working with Kaya was a pleasure. She demonstrated an exceptional ability to execute our vision above and beyond expectation. A wizard at Photoshop and Illustrator, Kaya was able to perform in an ever-changing environment, giving creative input on multiple projects. An overall pleasure to work with, and I hope to have an opportunity to work with her in the future.",
    author: "Dorian R.",
    org: "Business Analyst",
    rating: 5,
  },
  {
    quote:
      "Thank you for your impressive efforts on this Kaya, and on short notice as well. I appreciate how hectic those in-event dynamics can be, it's a testament to your talents to pull it off successfully and with a happy client!",
    author: "Karissa R.",
    org: "Project Manager & Event Lead",
    rating: 5,
  },
  {
    quote:
      "I can pinpoint the growth of our team to exactly when Kaya started working on our decks.",
    author: "VP of Innovation",
    org: "Enterprise Client",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "What kind of presentations do you design?",
    a: "Cinematic, motion-driven keynote and conference decks, investor pitch decks, brand and sales decks, and reusable template systems for enterprise teams. Most engagements are for high-stakes rooms: keynotes, fundraising, board meetings, and product launches.",
  },
  {
    q: "Do you design websites as well as presentations?",
    a: "Yes. Alongside keynotes and decks, I design brand-led websites, from a single landing page to a full redesign. It is often the same story told twice, so your brand feels like one thing on stage and on screen.",
  },
  {
    q: "What does a website project involve?",
    a: "Structure and story first, then design and motion. I shape the page narrative, design each section, add considered motion, and hand over either a build-ready design or a working responsive site, depending on what you need.",
  },
  {
    q: "Can you handle both the brand identity and the website?",
    a: "Yes. I can design the identity and the website together so the logo, type, colour and layout read as one system, as I did for The Language Attitude Institute.",
  },
  {
    q: "How does a typical project work?",
    a: "Every project starts with discovery: your goals, audience, and the raw material you already have. From there I shape the story and slide architecture, then design and animate the deck, refining with you through revision rounds until it is packaged and presentation-ready.",
  },
  {
    q: "How long does a deck take?",
    a: "Most keynote and pitch decks take two to four weeks depending on slide count, animation, and how finished the content is when we start. Template systems and larger narrative rebuilds run longer. Rush timelines are possible; tell me your date and I will let you know what is realistic.",
  },
  {
    q: "Can you support last-minute edits or be onsite at the event?",
    a: "Yes. I offer onsite and remote support for live events, including last-minute content changes, speaker-driven edits, and final QA in the room. Rush capability is built into executive and keynote engagements.",
  },
  {
    q: "Which tools and file formats do you work in?",
    a: "PowerPoint, Keynote, and Google Slides for the deck itself, with Figma, Illustrator, Photoshop, and After Effects for design and motion. Final files are delivered fully editable in your team's native format, along with any video or animation assets.",
  },
  {
    q: "What do you need from me to get started?",
    a: "Your talking points or existing deck, brand guidelines, the event or meeting date, and a sense of who is in the room. If the story is not fully formed yet, that is fine; building the narrative together is part of the work.",
  },
  {
    q: "How is pricing structured?",
    a: "Each engagement is scoped to what the story and the room require: slide count, animation, research and narrative work, and timeline. Send a few details through the contact form and I will follow up with a proposal.",
  },
];

export const PROJECT_TYPES = [
  "Keynote / Conference deck",
  "Investor / Pitch deck",
  "Website / Web design",
  "Brand & website system",
  "Template system",
  "Other",
];

export const BUDGET_RANGES = [
  "Under $5k",
  "$5k – $10k",
  "$10k – $20k",
  "$20k+",
  "Not sure yet",
];

export const SERVICES = [
  {
    title: "Keynotes and presentations",
    desc: "Launch keynotes, investor decks and conference openers, designed and animated to hold a room.",
  },
  {
    title: "Web design",
    desc: "Brand-led websites with clear structure and motion that feels considered, from landing pages to full redesigns.",
  },
];

export const SERVICES_NOTE =
  "Often the same story, told twice. I can design both so they feel like one brand.";

export const PRICING = [
  {
    name: "Foundation",
    tagline: "For a straightforward but polished engagement, built on content you've already developed.",
    prefix: "Starting at",
    price: "$4,500",
    unit: "",
    featured: false,
    features: [
      "Discovery",
      "Copy refinement",
      "Slide architecture",
      "Visual design",
      "Revisions",
      "File packaging",
    ],
  },
  {
    name: "Signature",
    tagline: "The flagship engagement, where talking points become an actual argument, built and designed together.",
    prefix: "Starting at",
    price: "$8,500",
    unit: "",
    featured: true,
    features: [
      "Discovery",
      "Research",
      "Story strategy",
      "Copy refinement",
      "Slide architecture",
      "Visual design",
      "Data visualization",
      "Revisions",
      "QA",
      "File packaging",
      "Client communication",
    ],
  },
  {
    name: "Executive Experience",
    tagline: "For C-suite, fundraising, board meetings, and keynote presentations, where the stakes, and the audience, are highest.",
    prefix: "Starting at",
    price: "$15,000",
    unit: "",
    featured: false,
    note: "Everything in Signature, plus:",
    features: [
      "Extended discovery and stakeholder input",
      "Rush capability",
      "Confidentiality handling",
      "Hands-on collaboration through delivery",
    ],
  },
  {
    name: "Studio Partner",
    tagline: "For companies that need an ongoing presentation design function, not a one-off project.",
    prefix: "",
    price: "$8,000",
    unit: "/ month",
    featured: false,
    features: [
      "Dedicated monthly capacity",
      "Consistent point of contact",
      "Priority turnaround",
      "Brand and template maintenance",
      "Ongoing story and slide support",
    ],
  },
];


export const PROJECTS = [
  {
    slug: "future-of-cybersecurity-motion-keynote",
    title: "The Future of Cybersecurity",
    discipline: "keynote",
    tag: "Keynote",
    subtitle: "Conference keynote",
    client: "Global Technology Consultancy",
    category: "Conference Keynote Deck",
    seoTitle: "The Future of Cybersecurity, Cinematic Keynote Deck | Kaya The Designer",
    seoDescription:
      "Cinematic conference keynote deck for a global technology consultancy, with presentation design, data visualization and motion graphics for cybersecurity trends.",
    coverAlt: "Cinematic keynote cover slide for The Future of Cybersecurity, a glowing blue horizon over a dark digital landscape",
    year: "2025",
    role: "Keynote Design · Narrative · Data Viz",
    tools: ["Figma", "Illustrator", "After Effects"],
    span: "lg:col-span-8 lg:row-span-2",
    cover: "/media/cybersecurity-cover.webp",
    heroBg: "/media/cybersecurity-cover.webp",
    summary:
      "This keynote was built for the innovation arm of a global technology consultancy, presented to enterprise clients to position the firm as a forward-looking authority on cloud security, data modernization, and emerging technology. As the sole designer embedded in the business unit, I built the presentation system end to end: structure, typography, data visualization and motion pacing, translating dense technical trend forecasting into a keynote experience that feels cinematic rather than corporate.",
    challenge:
      "Defence hardware is dense, technical and hard to sell in a room of generalist investors. We needed a narrative that felt inevitable: clarity without dumbing down, gravity without noise.",
    approach:
      "A restrained monochrome system with a single electric-steel accent. Every slide earns its place: one idea, one number, one image. Orbital motifs anchor the brand while typographic hierarchy carries the argument.",
    slides: [
      { url: "/media/cybersecurity-hero-slide.webp", alt: "Title slide of The Future of Cybersecurity keynote deck with bold typography over a dark cinematic backdrop" },
      { url: "/media/cybersecurity-branding.webp", alt: "Branding system for the cybersecurity keynote, monochrome palette, electric-steel accent and orbital motifs" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/k57hz0dv_Slides.webp", alt: "Grid of keynote slides showing data visualization and typographic hierarchy from The Future of Cybersecurity deck" },
      {
        url: "/media/cybersecurity-keynote-motion.mp4",
        webm: "/media/cybersecurity-keynote-motion.webm",
        poster: "/media/cybersecurity-keynote-motion-poster.webp",
        alt: "Motion graphics reel of The Future of Cybersecurity keynote presentation animating through its slides",
        type: "video",
        blurCorner: true,
      },
    ],
    stats: [{ k: "$42M", v: "Raised" }, { k: "14", v: "Slides" }, { k: "3wk", v: "Turnaround" }],
  },
  {
    slug: "chrome-intelligence-deck-template",
    title: "Chrome Intelligence",
    discipline: "keynote",
    tag: "Keynote",
    subtitle: "Deck template",
    client: "AI Commerce",
    category: "Template Design",
    seoTitle: "Chrome Intelligence, PowerPoint Deck Template | Kaya The Designer",
    seoDescription:
      "Premium PowerPoint deck template with an iridescent chrome identity: title, agenda, divider and content slide system for AI and tech brands by Kaya Amah.",
    coverAlt: "Iridescent chrome 3D form on black, cover visual of the Chrome Intelligence presentation template",
    year: "2025",
    role: "Deck template • Slide system • Visual identity",
    tools: ["PowerPoint", "Photoshop", "Adobe Firefly", "Adobe Stock"],
    span: "lg:col-span-4",
    cover: "/media/chrome-intelligence-cover.webp",
    summary:
      "A full presentation system built for AI and tech-forward brands, but don't let the chrome finish fool you. The bones underneath (title, agenda, dividers, comparison layouts, content slides) are built to hold any story, in any industry. Swap the palette and imagery, and the same framework carries a wellness brand, a finance pitch, or a product launch just as confidently. This one just happens to speak fluent AI.",
    challenge:
      "Communicate a paradigm shift in retail without slipping into hype. The deck had to feel as premium and intelligent as the product itself.",
    approach:
      "A dark, jewel-toned system with glassmorphic product frames and bold performance metrics. UI mockups float in space; numbers do the talking.",
    slides: [
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/nwj86eoz_template%20portfolio%20%5BSlide%201%5D.webp" , alt: "Chrome Intelligence template title slide, iridescent chrome face beside 'Template Deck Title' on a violet gradient" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/2ysz1d6r_template%20portfolio%20%5BSlide%202%5D.webp" , alt: "Section divider slide from the Chrome Intelligence template with a chrome android bust and large numeral" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/hxk7ws2k_template%20portfolio%20%5BSlide%203%5D.webp" , alt: "Agenda slide layout with a numbered seven-item list and chrome helmeted figure, Chrome Intelligence template" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/2vnm0m71_template%20portfolio%20%5BSlide%204%5D.webp" , alt: "Text and image slide from the Chrome Intelligence template featuring a holographic 3D brain illustration" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/qvm2d9i8_template%20portfolio%20%5BSlide%205%5D.webp" , alt: "Two-column body copy slide with a chrome hand holding a glowing orb, Chrome Intelligence PowerPoint template" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/1mec9gc0_template%20portfolio%20%5BSlide%206%5D.webp" , alt: "Text plus vertical image slide with an iridescent liquid sphere, Chrome Intelligence deck template" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/7dftvh9z_template%20portfolio%20%5BSlide%209%5D.webp" , alt: "Dual categories and impact overview data slide with a purple bar chart, Chrome Intelligence template" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/82zw75y0_template%20portfolio%20%5BSlide%2010%5D.webp" , alt: "Data highlight slide layout showing large 100%, 75% and 25% statistics over a chrome wave, Chrome Intelligence template" },
    ],
    stats: [{ k: "428%", v: "Revenue Lift" }, { k: "12", v: "Slides" }, { k: "2wk", v: "Turnaround" }],
  },
  {
    slug: "unsinkable-cinematic-keynote-deck",
    title: "Unsinkable",
    discipline: "keynote",
    tag: "Keynote",
    subtitle: "Cinematic keynote",
    client: "Uberflip",
    category: "Concept, narrative, and design",
    seoTitle: "Unsinkable, Cinematic Keynote Deck for Uberflip | Kaya The Designer",
    seoDescription:
      "Concept, narrative and presentation design for Uberflip's Unsinkable keynote, a cinematic, motion-driven deck with animated slides, built from scratch.",
    coverAlt: "White life buoy floating on fuchsia water, cover visual of the Unsinkable keynote deck for Uberflip",
    year: "2024",
    role: "Keynote design • Narrative development • Presentation system",
    tools: ["PowerPoint", "Photoshop", "After Effects"],
    span: "lg:col-span-4",
    cover: "/media/unsinkable-cover.webp",
    summary:
      "Uberflip handed over talking points and brand colours, and the story, structure and pacing are built from scratch. A real boat fire becomes the through-line for a customer experience framework, using humor and a bit of drama to make an abstract topic (personalization, trust, engagement) land the way a good conference talk should. This one's proof of range: not just decks that look good, but decks with a point of view.",
    challenge: "Make a static medium feel like cinema. Hold attention for a full keynote without a single dull frame.",
    approach: "Filmic color grade, dramatic light and typography timed to a beat. Every transition choreographed.",
    slides: [
      {
        url: "/media/unsinkable-animations-reel.mp4",
        webm: "/media/unsinkable-animations-reel.webm",
        poster: "/media/unsinkable-animations-reel-poster.webp",
        alt: "Animations reel of the Unsinkable keynote deck for Uberflip showing motion-driven slide transitions",
        type: "video",
        label: "Animations Reel",
      },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/473u2ymx_UberFlip_Keynote2022_V3_2-25-22_3.2-v2%20%5BSlide%205%5D.webp" , alt: "Bold magenta typographic slide reading 'This is a true story. My trip to Costa Rica' from the Unsinkable keynote for Uberflip" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/vxfdfrgs_UberFlip_Keynote2022_V3_2-25-22_3.2-v2%20%5BSlide%2027%5D.webp" , alt: "Data visualization slides from the Unsinkable keynote, minutes of video watched by year and primary forms of media bar charts" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/6gg4v919_UberFlip_Keynote2022_V3_2-25-22_3.2-v2%20%5BSlide%2031%5D.webp" , alt: "Unsinkable keynote slide with a large smiley graphic and the words 'I cried' in Uberflip magenta" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/a4q00t26_UberFlip_Keynote2022_V3_2-25-22_3.2-v2%20%5BSlide%2038%5D.webp" , alt: "Unsinkable keynote slide 'Your music. Your podcasts. Your Home.' with a Spotify app phone mockup" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/jknyr69h_UberFlip_Keynote2022_V3_2-25-22_3.2-v2%20%5BSlide%2048%5D.webp" , alt: "Unsinkable keynote slide 'Made for you' showing a Spotify Your Top Songs 2019 playlist mockup" },
    ],
    stats: [{ k: "60fps", v: "Motion" }, { k: "9", v: "Scenes" }, { k: "1", v: "Standing O" }],
  },
  {
    slug: "aurevon",
    title: "Aurevon",
    discipline: "web",
    tag: "Web",
    subtitle: "Website redesign proposal",
    client: "",
    category: "Website redesign proposal",
    seoTitle: "Aurevon, Website Redesign Proposal | Kaya The Designer",
    seoDescription:
      "Aurevon is a website redesign proposal by Kaya Amah: a working prototype designed, built and pitched to a technology consultancy, shown under a fictional name to respect the client.",
    coverAlt: "Aurevon website redesign cover, a glassy blue-green 3D torus held in a crystalline hand on a blue and black gradient glow",
    year: "2025",
    role: "Concept · Art direction · Web design · Motion",
    tools: ["XD", "Figma", "Photoshop"],
    cover: "https://static.prod-images.emergentagent.com/jobs/ec872f1e-40ea-45ab-a3c0-6329cc54fb21/images/d49d380c7807e8b28f100081c0985c4b3d1682b6747b7e044fbef87bfe695b46.jpeg",
    heroBg: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/4b40167b747b1928_Hero.png",
    heroVisual: { src: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/2cc45c285a66b342_blue_graphics_graphic_design_19.png", alt: "Aurevon brand visual, a luminous blue glass torus floating on a dark background", mask: false, maxH: "122%", boxWidth: "w-[60vw] max-w-[1120px]" },
    summary:
      "I saw a technology consultancy whose work was ahead of its website, so I designed and built a working prototype of what the site could be and pitched it to the company. The timing wasn't right for a full revamp, but the proposal shows how I approach a brand: listen to what the company sells, then make the website feel like it. Shown here under a fictional name, Aurevon, to respect the client.",
    slides: [
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/4b40167b747b1928_Hero.png", alt: "Aurevon website redesign title visual, a glassy blue-green torus held in a crystalline hand beside the words Website Redesign" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/27524bb9e8e764a6_Branding.png", alt: "Aurevon colour and typography system, a glassy blue-green torus on black annotated with hex values and the Geist typeface" },
      { type: "text", text: "Listen to what the company sells, then make the website feel like it." },
      { type: "video", url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/5419b7cd809ad2d4_before-after-slider.mp4", webm: "/media/aurevon-beforeafter.webm", poster: "/media/aurevon-beforeafter-poster.webp", label: "Before and after", alt: "Before and after slider comparing the consultancy's original website with the redesigned Aurevon prototype" },
      { type: "video", url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/d56dcadb5d66b2ca_Aurevon%20reel.mp4", webm: "/media/aurevon-reel.webm", poster: "/media/aurevon-reel-poster.webp", label: "Aurevon reel", alt: "Animated reel of the Aurevon website redesign prototype, scrolling through the hero, why Aurevon and offerings sections" },
      { type: "video", url: "/media/aurevon-why.mp4", webm: "/media/aurevon-why.webm", poster: "/media/aurevon-why-poster.webp", label: "Why Aurevon", alt: "Why Aurevon reel, walking through the reasoning behind the website redesign proposal" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/311e67e18ccd1cd6_Slides.webp", alt: "Aurevon prototype pages stacked in order, from the Possibility starts with Technology hero down to the contact section" },
    ],
  },
  {
    slug: "language-attitude-institute",
    title: "Language Attitude Institute",
    discipline: "web",
    tag: "Web",
    subtitle: "Identity and website",
    client: "The Language Attitude Institute",
    category: "Identity and website",
    seoTitle: "Language Attitude Institute, Logo & Website | Kaya The Designer",
    seoDescription:
      "Logo redesign and website for The Language Attitude Institute by Kaya Amah: a warm, inclusive visual identity that synthesises many voices into one unifying brand.",
    coverAlt: "Language Attitude Institute cover, a glossy white chameleon figurine glowing in teal on black",
    year: "2024",
    role: "Brand identity · Logo design · Web design",
    tools: ["Illustrator", "Wix", "Photoshop"],
    cover: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/0671a7e72af144c5_Glossy%20White%20Chameleon%20Figurine.webp",
    heroBg: "https://static.prod-images.emergentagent.com/jobs/ec872f1e-40ea-45ab-a3c0-6329cc54fb21/images/fe6e5b28a817f6480eda207a5e0638be9aa6023271c7a08b3f23dcd0fd723761.jpeg",
    heroVisual: { src: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/a9b1accd4a650099_white-chameleon-transparent.png", alt: "Glossy white chameleon, the Language Attitude Institute brand mascot, glowing on black", mask: false, maxH: "62%", boxWidth: "w-[40vw] max-w-[620px]" },
    summary:
      "A logo redesign and brand-led website for The Language Attitude Institute. The work began with the mark that now represents the institute, then extended into a website built to carry that identity and the diverse communities it serves.",
    liveUrl: "https://www.languageattitude.org",
    liveLabel: "www.languageattitude.org",
    slides: [
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/3832a7437ca075df_Hero%20LAI.png", alt: "Language Attitude Institute identity hero, a teal chameleon beside the words Identity Revamp on black" },
      { type: "text", text: "It started with the mark that now represents the institute." },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/1a6c2777260fd2f6_logo-journey.webp", alt: "Language Attitude Institute logo redesign journey, from the original tree-and-face mark through explored concepts to the final colourful tree inside an amber circle" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/bd3be11e2a12d246_Branding%20LAi.png", alt: "Language Attitude Institute brand system, the colourful tree logo with the Poppins typeface and a palette of amber, teal, pink and blue swatches" },
      { type: "text", text: "Then a website designed to fit the brand." },
      { type: "video", url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/b6080fd2eb876b29_Language%20attitude%20reel.mp4", webm: "/media/lai-reel.webm", poster: "/media/lai-reel-poster.webp", label: "Website reel", alt: "Reel of the Language Attitude Institute website scrolling through its pages" },
      { type: "quote", text: "She designed the logo that now represents our institute, a visual identity that not only captures the spirit of our mission but also resonates deeply with the diverse communities we serve. She demonstrated patience with the board, attentiveness to intercultural dynamics, and an impressive capacity to synthesise diverse voices into a unifying design.", author: "Veronica Q., Co-founder, The Language Attitude Institute" },
    ],
  },
  {
    slug: "data-visualisation",
    title: "Data Visualisation",
    discipline: "keynote",
    tag: "Data Viz",
    subtitle: "Charts that tell the story",
    client: "",
    category: "Data visualisation",
    compact: true,
    seoTitle: "Data Visualisation, Infographics & Charts | Kaya The Designer",
    seoDescription:
      "A short selection of data visualisation and infographic work by Kaya Amah: turning dense numbers into clear, branded, on-stage visuals for decks and reports.",
    coverAlt: "Data visualisation card, a translucent blue and teal glass 3D pie chart on a dark frosted-glass background",
    year: "2026",
    role: "Data visualisation · Infographics · Slide design",
    tools: ["PowerPoint", "Photoshop", "Illustrator"],
    cover: "https://static.prod-images.emergentagent.com/jobs/ec872f1e-40ea-45ab-a3c0-6329cc54fb21/images/3153ff3163b753f6ac39af3b3f19aecdc7d7d8e866f819a449bf6b3b1b68c923.jpeg",
    summary:
      "A small set of data visualisation pieces, just to show that the numbers get the same care as everything else. Dense figures become clear, branded visuals that hold up on a big screen: radial comparisons, pictographs and layered infographics that make the takeaway obvious in a second.",
    slides: [
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/524eb1019b8a3ebb_data%20viz%20slides%20%5BSlide%201%5D.webp", alt: "Radial bar chart of gross profit by service type on a deep blue gradient, with a large total figure and category spokes" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/331f56872578df5e_data%20viz%20slides%20%5BSlide%202%5D.webp", alt: "Data insights pictograph showing gross profit by rep with a glass piggy bank and a grid of people icons" },
      { url: "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/843a056630f85883_data%20viz%20slides%20%5BSlide%203%5D.webp", alt: "Client analysis infographic comparing 2025 and 2026 data points with coin stacks and classical bust illustrations" },
    ],
  },
];

export const MANIFESTO = [
  { n: "01", title: "Story before slides", body: "Every deck begins as an argument, not a template. We find the throughline that makes your case feel inevitable, then design around it." },
  { n: "02", title: "Restraint is luxury", body: "One idea per slide. Generous space. Nothing decorative. The confidence to leave the room quiet is what reads as premium." },
  { n: "03", title: "Motion with meaning", body: "Animation is choreography, not confetti. Every transition guides the eye and controls the pace of the pitch." },
];
